import palette from "../palette";

export default {
  root: {
    backgroundColor: palette.chip,
  },
  label: {
    color: palette.text.primary,
  },
  deleteIcon: {
    color: palette.icon,
  },
};
